import useIsDesktop from "@hooks/useIsDesktop"
import useNavigationLinks from "@hooks/useNavigationLinks"
import useRouter from "@hooks/useRouter"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useUser from "@hooks/useUser"

import filterUserLinks from "@utils/filterUserLinks"

import { AccessCheck } from "@particles"

import { NavTopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { JOBS_ROUTES } from "@routes/jobs"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { JOBS_LIST_CONTROLS_VIEW } from "@constants/storage"

import JobCardView from "./views/JobCardView/JobCardView"
import JobTableView from "./views/JobTableView/JobTableView"
import JobTimelineView from "./views/JobTimelineView/JobTimelineView"

function JobListContent() {
    const { user } = useUser()
    const isDesktop = useIsDesktop()
    const [createRoute] = useSlugExtractor([JOBS_ROUTES.CREATE])

    const router = useRouter()
    const { jobs: jobsLink } = useNavigationLinks()

    const sublinks = filterUserLinks(jobsLink.subLinks, user)

    return (
        <>
            <ViewTypesProvider
                viewTypes={["table", "card", "timeline"]}
                viewTypeKey={JOBS_LIST_CONTROLS_VIEW}
                defaultViewType={isDesktop ? "table" : "card"}
            >
                {({ activeViewType }) => (
                    <>
                        <NavTopBar.Root>
                            <NavTopBar.Header>
                                <NavTopBar.NavTopBarHeaderStart>
                                    <NavTopBar.PageTitle
                                        label={objectMap.job.labelPlural}
                                        icon={objectMap.job.iconActive}
                                        navigationItems={
                                            sublinks.length > 1
                                                ? sublinks.map((item) => ({
                                                      label: item.label,
                                                      value: item.path,
                                                      isActive: item.label === "Jobs",
                                                  }))
                                                : undefined
                                        }
                                        onNavigationItemSelect={(item) => {
                                            router.push(item.value)
                                        }}
                                    />
                                </NavTopBar.NavTopBarHeaderStart>
                                <NavTopBar.NavTopBarHeaderEnd>
                                    <NavTopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            jobs_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                jobs_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <NavTopBar.SearchButton scope="Jobs" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <AccessCheck
                                        permissions={{
                                            jobs_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <NavTopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </NavTopBar.NavTopBarHeaderEnd>
                            </NavTopBar.Header>
                        </NavTopBar.Root>
                        {activeViewType === "card" && <JobCardView />}
                        {activeViewType === "table" && <JobTableView />}
                        {activeViewType === "timeline" && <JobTimelineView />}
                    </>
                )}
            </ViewTypesProvider>
        </>
    )
}

export default function JobList() {
    return (
        <AppFrame.Root collaborationRoomName="job-list">
            <JobListContent />
        </AppFrame.Root>
    )
}
